import React, { useEffect, useState } from 'react'
import Layout from '../../../brands/components/Layout'
import { useFormik } from 'formik'
import { InputField } from '../../../../components'
import SelectField from '../../../../components/Form/Select'
import TextAreaField from '../../../../components/Form/TextArea'
import { useLocation, useNavigate } from 'react-router-dom'
import { uploadtaskSchema } from '../schema'
import { useAppDispatch } from '../../../../redux/hook'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { getLookupValues } from '../../../userslisting/createuser/api'
import { Button } from 'react-bootstrap'
import './index.css'
import { uploadTask, viewResourceDetail } from '../../viewresources/api'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { MAX_CHAR_COUNT } from '../../../../utils/index'

const UploadResources: React.FC = () => {
    const [fileName, setFileName] = useState('')
    const [file, setFile] = useState<any>()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const id = queryParams.get('id')
    const resourceid = queryParams.get('resourceId')
    const [resourcetypeOptions, setResourceTypeOptions] = useState<
        { label: string; value: string; id?: number | null }[]
    >([])

    useEffect(() => {
        dispatch(SHOW_LOADER())

        const lookups = async () => {
            try {
                const lookupValues = await getLookupValues()
                const resourceTypeData = lookupValues?.data?.filter(
                    (item: any) => item.lookUpType === 'ResourceType'
                )
                // Transform filtered results into label and value format for ResourceType
                const transformedFreqTypeData = resourceTypeData.map(
                    (item: any) => ({
                        label: item.lookUpValue,
                        value: item.lookUpValue,
                        id: item.id,
                    })
                )
                setResourceTypeOptions(transformedFreqTypeData)
                dispatch(HIDE_LOADER())
            } catch (err) {
                // Handle any errors here
                console.error('Error fetching:', err)
                dispatch(HIDE_LOADER())
            }
        }
        lookups()
    }, [])

    const getResourceTypeId = (
        resourceType: string | null | undefined | number
    ): string | any => {
        const type = resourcetypeOptions.find(
            (type) => type.value === resourceType
        )
        return type ? type?.id : null
    }

    const handleSubmit = async () => {
        if (formik.values.description.length >= 2000) {
            dispatch(
                SHOW_NOTIFICATION({
                    type: 'error',
                    message:
                        'Description exceeds the maximum limit of 2000 characters',
                })
            )
            return
        }
        dispatch(SHOW_LOADER())
        const fomdata = new FormData()
        fomdata.append('ResourceId', resourceid ? resourceid : '')
        fomdata.append('ResourceName', formik.values.title)
        fomdata.append('ResourceTypeId', getResourceTypeId(formik.values.type))
        fomdata.append('Link', formik.values.link)
        fomdata.append('File', file)
        fomdata.append('Description', formik.values.description)
        fomdata.append('ResourceParentFolderId', id ? id : '')

        try {
            const response = await uploadTask(fomdata)
            dispatch(HIDE_LOADER())
            dispatch(
                SHOW_NOTIFICATION({
                    type: 'success',
                    message: resourceid
                        ? ' Your Task has been updated'
                        : 'Task Added successfully',
                })
            )
            if (response.status === 200) {
                navigate(-1)
            }
        } catch (err) {
            // Handle any errors here
            console.error('Error fetching:', err)
            dispatch(HIDE_LOADER())
        }
    }

    const formik = useFormik({
        initialValues: {
            title: '',
            type: '',
            link: '',
            filetype: fileName,
            description: '',
            isEditing: false,
        },
        enableReinitialize: false,
        onSubmit: handleSubmit,
        validationSchema: uploadtaskSchema,
    })

    useEffect(() => {
        if (resourceid) {
            const getResourceDetails = async () => {
                try {
                    const response = await viewResourceDetail(resourceid)
                    const {
                        link,
                        resourceName,
                        description,
                        resourceTypeId,
                        resourcePath,
                    } = response?.data || {}

                    formik.setFieldValue('title', resourceName)
                    formik.setFieldValue('link', link)
                    formik.setFieldValue('description', description)
                    formik.setFieldValue(
                        'type',
                        resourcetypeOptions
                            ?.find(
                                (resource: any) => resource.id == resourceTypeId
                            )
                            ?.value?.toString()
                    )
                    const fileName = resourcePath?.split('/').pop() || ''
                    setFileName(fileName)
                    formik.setFieldValue('filetype', fileName)
                    formik.setFieldValue('isEditing', true)
                    // dispatch(HIDE_LOADER())
                    // dispatch(
                    //     SHOW_NOTIFICATION({
                    //         type: 'success',
                    //         message: 'Program Added successfully',
                    //     })
                    // )
                    // formik.resetForm()
                    // setFile('')
                    // setFileName('')
                } catch (err) {
                    // Handle any errors here
                    console.error('Error fetching:', err)
                    dispatch(HIDE_LOADER())
                }
            }
            getResourceDetails()
        }
    }, [resourceid, resourcetypeOptions])
    const fileInputRef = React.useRef<HTMLInputElement | null>(null)
    const handleFileChange = (e: any) => {
        const fileObj = e.target.files[0]
        formik.setFieldValue('filetype', fileObj?.name)
        !resourceid && formik.setFieldValue('link', '')
        setFileName(fileObj ? fileObj?.name : '')
        setFile(fileObj)
        formik.setFieldTouched('filetype', true)
        // // Manually trigger onBlur event
        // setTimeout(() => {
        //     if (fileInputRef.current) {
        //         console.log('-------', fileInputRef.current)
        //         fileInputRef.current.click()
        //     }
        // }, 1000)
    }
    return (
        <div>
            <Layout>
                <div className="">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4>{resourceid ? 'Update Task' : 'Upload Task'} </h4>
                        <div className="col-auto me-2">
                            <Button
                                className="button button-primary"
                                type="button"
                                onClick={() => navigate(-1)}
                            >
                                BACK
                            </Button>
                        </div>
                    </div>

                    <div className="upload-form">
                        <form onSubmit={formik.handleSubmit}>
                            <div className="row mrg-top">
                                <div className="col-sm-6 col-md-12">
                                    <InputField
                                        type="text"
                                        lable={'Title'}
                                        name="title"
                                        value={formik.values.title}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.errors.title}
                                        touched={formik.touched.title}
                                    />
                                </div>
                            </div>

                            <div className="row mrg-top">
                                <div className="col-sm-6 col-md-12">
                                    <SelectField
                                        name="type"
                                        label="Resource Type"
                                        options={[
                                            {
                                                value: '',
                                                label: 'Select',
                                            },
                                            ...resourcetypeOptions,
                                        ]}
                                        value={formik.values.type}
                                        onChange={(e) => {
                                            formik.handleChange(e)
                                            if (fileName) {
                                                formik.values.filetype = ''
                                                formik.setFieldValue(
                                                    'filetype',
                                                    ''
                                                )
                                                setFileName('')
                                            }
                                            if (
                                                formik.values.type?.toLowerCase() ===
                                                'link'
                                            ) {
                                                formik.setFieldValue('link', '')
                                            }
                                        }}
                                        onBlur={formik.handleBlur}
                                        error={formik.errors.type}
                                        touched={formik.touched.type}
                                        defaultValue="option1"
                                    />
                                </div>
                            </div>

                            <div className="row mrg-top">
                                <div className="col-sm-6 col-md-12">
                                    <InputField
                                        type="text"
                                        lable={'Link'}
                                        name="link"
                                        value={formik.values.link}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={
                                            formik.values.type &&
                                            formik.values.type?.toLowerCase() ===
                                                'link'
                                                ? formik.errors.link
                                                : ''
                                        }
                                        touched={formik.touched.link}
                                        disabled={
                                            !formik.values.type ||
                                            formik.values.type?.toLowerCase() !==
                                                'link'
                                                ? true
                                                : false
                                        }
                                    />
                                </div>
                            </div>
                            <div className="row mrg-top">
                                <div className="">
                                    <label> File</label>
                                    <div className="file-section">
                                        <span
                                            ref={fileInputRef}
                                            className={
                                                !formik.values.type ||
                                                formik.values.type?.toLowerCase() ===
                                                    'link'
                                                    ? 'dis-span'
                                                    : ''
                                            }
                                        >
                                            {fileName}
                                        </span>
                                        <input
                                            type="file"
                                            className="input-file"
                                            id="file"
                                            name="file"
                                            onChange={(e) => {
                                                handleFileChange(e)
                                            }}
                                            onBlur={formik.handleBlur}
                                            // value={formik.values.filetype}
                                            disabled={
                                                !formik.values.type ||
                                                formik.values.type?.toLowerCase() ===
                                                    'link'
                                            }
                                        />
                                        <label
                                            htmlFor="file"
                                            className="btn btn-upload"
                                        >
                                            BROWSE
                                        </label>
                                    </div>
                                    <div>
                                        {formik.values.type &&
                                        formik.values.type?.toLowerCase() !==
                                            'link' ? (
                                            <p
                                                style={{
                                                    color: 'red',
                                                }}
                                            >
                                                {formik.errors.filetype}
                                            </p>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="row mrg-top">
                                <div className="col-sm-6 col-md-12">
                                    <TextAreaField
                                        name="description"
                                        label="Description"
                                        placeholder=""
                                        value={formik.values.description}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.errors.description}
                                        touched={formik.touched.description}
                                        defaultValue=""
                                        rows={10}
                                        maxLength={MAX_CHAR_COUNT}
                                    />
                                </div>
                            </div>

                            <div className="row mt-4 mb-4">
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <div className="col-auto me-2">
                                            <Button
                                                className="button button-primary"
                                                type="button"
                                                onClick={() => navigate(-1)}
                                            >
                                                BACK
                                            </Button>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="button-block button-block-inline">
                                            <Button
                                                className="button button-primary me-5"
                                                type="submit"
                                            >
                                                {resourceid
                                                    ? `UPDATE`
                                                    : ' UPLOAD'}
                                            </Button>
                                            <Button
                                                className="upload-cancel button button-outline"
                                                type="button"
                                                onClick={() => navigate(-1)}
                                            >
                                                CANCEL
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        {/* )}
                        </Formik> */}
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default UploadResources
